/** Acts as the default configuration for instances of PhoneNumberField */
export const fsPhoneNumberFieldDefaults = {
    allowInternationalNumber: false,
    autocomplete: 'off',
    autofocus: false,
    compact: false,
    disabled: false,
    helperText: '',
    hideLabel: false,
    id: undefined,
    name: null,
    noValidate: false,
    placeholder: '',
    readOnly: false,
    required: true,
    showError: false,
    useMaskedValue: false,
    value: undefined
};
export const phoneNumberFieldManagerConfigDefaults = {
    allowInternationalNumber: fsPhoneNumberFieldDefaults.allowInternationalNumber,
    formatOnBlur: false,
    useMaskedValue: fsPhoneNumberFieldDefaults.useMaskedValue
};
//# sourceMappingURL=types.js.map